import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, delay } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  // tslint:disable-next-line: variable-name
  apiUrl = 'http://';
  handleError: any;

  signedIn = false;
  isAdmin = false;
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  getJSON(url: string): Observable<any> {
    return this.http.get(url);
  }

  getApiUrl(): string {
    return this.apiUrl;
  }

  // sampleRequest(): Observable<any[]> {
  //   return this.http.get<any[]>(this.apiUrl).pipe(
  //     tap((data) => data),
  //     catchError(this.handleError)
  //   );
  // }

  getIsAdmin(): boolean {
    return this.isAdmin;
  }

  isSignedIn() {
    return this.signedIn;
  }

  signOut() {
    // For demo only
    this.signedIn = false;
    this.isAdmin = false;
  }

  signIn() {
    // For demo only
    this.signedIn = true;
    this.isAdmin = false;
  }

  signInAdmin() {
    // For demo only
    this.signedIn = true;
    this.isAdmin = true;
  }

  getPredefinedBillsMessages(): any[] {
    return [
      { id: 1, name: 'Factura pendiente' },
      { id: 2, name: 'Factura bla bla' },
    ];
  }

  getItemDetails(id: number, obj: any[]): any[] {
    for (const item of obj) {
      if (item.id === id) {
        return item;
      }
    }
    return [];
  }
  getItemSpecificDetail(id: number, key: string, obj: any[]): any {
    for (const item of obj) {
      if (item.id === id) {
        return item[key];
      }
    }
    return '';
  }
}
